import React, { useState, useEffect } from 'react';

import { Form, Typography, Button, Modal, notification, Divider, Spin, InputNumber, Row, Col, Descriptions, Table } from 'antd';
import moment from 'moment';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import ShowEmail from '../../../../../../components/ShowEmail';

const langContext = "reserved-area.construction";

const { Text, Title } = Typography;

export default function({construction_uid, uid, onClose}) {

  const intl = useIntl();

  const columns = [
    {
      title: <strong><FormattedMessage id={`reserved-area.marketplace.service.fields.client`} /></strong>,
      dataIndex: ['client','name'],
      key: 'client_name',
    },
    {
      title: <strong><FormattedMessage id={`reserved-area.marketplace.service.fields.code`} /></strong>,
      dataIndex: ['service','code'],
      key: 'service.code',
    },
    {
      title: <strong><FormattedMessage id={`reserved-area.marketplace.service.fields.service-type`} /></strong>,
      dataIndex: ['service','service_type','description','pt'],
      key: 'service_type.description',
    },
    {
      title: <strong><FormattedMessage id={`reserved-area.marketplace.service.fields.waste-type`} /></strong>,
      dataIndex: ['service','waste_type','description','pt'],
      key: 'waste_type.description',
    },
    {
      title: <strong>{`${intl.formatMessage({id: `reserved-area.marketplace.fields.distance`})} (Km)`}</strong> ,
      dataIndex: 'distance',
      key: 'distance',
    },
    {
      title: <strong>{`${intl.formatMessage({id: `reserved-area.marketplace.fields.environmental-impacts`})}`}</strong> ,
      dataIndex: 'environmental_impacts',
      key: 'environmental_impacts',
    },
    {
      title: <strong>{`${intl.formatMessage({id: `reserved-area.marketplace.fields.total-price`})} (€)`}</strong>,
      dataIndex: 'total_price',
      key: 'total_price',
    }
  ]
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [firstLoad, setFirstLoad] = useState (true)
  const [newTableData, setTableDataBool] = useState(true);
  const [apiData, setData] = useState([]);
  const [dataArray, setDataArray] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    if (uid && firstLoad) {
      _service({
        method: 'GET',
        url: '/construction/waste/produce',
        data: { uid },
        success: (response) => {
          setDataArray({
            amount: response.json.amount,
            estimated_date: response.json.estimated_date,
            mu_code: response.json.measurement_unit.code, 
            mu_description: response.json.measurement_unit.description, 
            waste_type: response.json.waste_type, 
            radius: response.json.radius
          })
          setLoadingData(false)
        },
        fail: (e) => {
          notification["error"]({
            message: 'Erro no carregamento dos dados dos Residuos a produzir',
            description: e.response.json.error,
          });
        }
      });
    }

    if(firstLoad == true && dataArray.length > 0) {
      getByRadius();
      setFirstLoad(false)
    }
    
    if(apiData != null && apiData != undefined && apiData != [] && newTableData && Object.keys(dataArray).length > 0) {
      getTotal();
    }
    else {
      setTableData([])
      setTableDataBool(false)
    }

    

  }, [apiData]); 


  function getByRadius(actualRadius) {

    if(!actualRadius && actualRadius == null) {
      actualRadius = dataArray.radius
    }

    if(actualRadius == undefined) {
      actualRadius = 1
    }

    _service({
      method: 'GET',
      url: '/construction/calculation/produce/list',
      data: {
        radius: actualRadius,
        waste_type_code: dataArray.waste_type.code,
        construction_uid: construction_uid
      },
      success: (response) => {
        setData(response.json)
      },
      fail: (e) => {
        notification["error"]({
          message: 'Erro no carregamento dos dados dos Residuos a consumir',
          description: e.response.json.error,
        });
      }
    });
  }

  
  function getTotal() {
    _service({
      method: 'GET',
      url: '/construction/calculation/produce/calc',
      data: {
        list: JSON.stringify(apiData),
        amount: dataArray.amount,
        measurement_unit_code: dataArray.mu_code,
        density: dataArray.waste_type.density
      },
      success: (response) => {
        setTableDataBool(false)
        setTableData(response.json.result);
      },
      fail: (e) => {
        notification["error"]({
          message: 'Erro no carregamento dos dados dos Residuos a consumir',
          description: e.response.json.error,
        });
      }
    });
  }

  const getStep = (value) => {
    setTableDataBool(true)
    getByRadius(value)
  }
  
  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    if(onClose) {
      onClose()
    }
  };

  const onTableRowExpand = (expanded, record) => {
    const keys = [];
    if(expanded){
        keys.push(record.uid);
    }

    setExpandedRowKeys(keys);
  }
  
  


  return(
    <Modal
      title={intl.formatMessage({id: langContext + '.button.see-marketplace'})}
      visible={true}
      width={'70%'}
      maskClosable
      footer={[
        <Button type="primary" onClick={() => closeModal()}>
          <FormattedMessage id={`${langContext}.button.close`} />
        </Button>]}>
      {loadingData ? (<Spin/>) : 
      <Form>
        <Row gutter={16}>
          <Col span={10}>
            <Title level={4}><FormattedMessage id={`reserved-area.marketplace.fields.details`} /></Title>
            <p>{intl.formatMessage({id: langContext + '.fields.distance'})}: <InputNumber onChange={(step) => {getStep(step)}} min={1} defaultValue={dataArray.radius} style={{width: '40px !important'}} /></p>
            <p>{intl.formatMessage({id: langContext + '.fields.estimated-date'})}: <Text strong>{dataArray.estimated_date}</Text></p>
          </Col>
          <Col>
            <Divider type='vertical' style={{'height':'100%'}}/>
          </Col>
          <Col span={10}>
            <Title level={4}><FormattedMessage id={`reserved-area.marketplace.fields.waste`}/></Title>
            <p>{intl.formatMessage({id: langContext + `.fields.waste-type`})}: 
              <Text strong> {intl.locale == 'pt-pt' ? dataArray.waste_type.description.pt : dataArray.waste_type.description.en}</Text>
            </p>
            <p>{intl.formatMessage({id: langContext + `.fields.amount`})}:
              <Text strong> {dataArray.amount} {intl.locale == 'pt-pt' ? dataArray.mu_description.pt : dataArray.mu_description.en}</Text>
            </p>
          </Col>
        </Row>
        <Divider/>
        <Title level={4}><FormattedMessage id={`reserved-area.marketplace.fields.prices`}/></Title>
        <Table
          loading={newTableData}
          columns={columns}
          dataSource={tableData}
          expandedRowKeys={expandedRowKeys}
          onExpand={onTableRowExpand}
          rowKey={(record) => (record.uid)}
          expandable={{
            expandedRowRender: (record) => (
              <div>
                <Descriptions style={{'margin':'10px 0'}} title={`${intl.formatMessage({id: `reserved-area.marketplace.fields.prices`})}`} layout={'vertical'} bordered size={"small"}>
                  <Descriptions.Item span={0.5} label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.shipping-price`})} (€)`}>{record.shipping_price}</Descriptions.Item>
                  <Descriptions.Item span={0.5} label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.service-price`})} (€)`}>{record.service_price}</Descriptions.Item>
                  <Descriptions.Item span={0.5} label={`${intl.formatMessage({id: `reserved-area.service.fields.price`})} (€/${record.measurement_unit.code})`}>{record.price}</Descriptions.Item>
                  <Descriptions.Item span={0.5} label={`${intl.formatMessage({id: 'components.email-show.title'})}`}><ShowEmail email={record.client.client_email} data={record.client}/></Descriptions.Item>
                </Descriptions>
                <Descriptions style={{'margin':'0 0 10px'}} title={`${intl.formatMessage({id: `reserved-area.marketplace.fields.gwp-costs`})}`} layout={'vertical'} bordered size={"small"}>
                  <Descriptions.Item label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.gwp-transport`})}`}>{record.gwp_transport}</Descriptions.Item>
                  <Descriptions.Item label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.gwp-service`})}`}>{record.gwp_service}</Descriptions.Item>
                  <Descriptions.Item label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.gwp-total`})}`}>{record.gwp_total}</Descriptions.Item>
                </Descriptions>
                <Descriptions style={{'margin':'0 0 10px'}} title={`${intl.formatMessage({id: `reserved-area.marketplace.fields.nre-costs`})}`} layout={'vertical'} bordered size={"small"}>
                  <Descriptions.Item label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.nre-transport`})}`}>{record.nre_transport}</Descriptions.Item>
                  <Descriptions.Item label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.nre-service`})}`}>{record.nre_service}</Descriptions.Item>
                  <Descriptions.Item label={`${intl.formatMessage({id: `reserved-area.marketplace.fields.nre-total`})}`}>{record.nre_total}</Descriptions.Item>
                </Descriptions>
              </div>
            )
          }}
          size="small"
          />
      </Form>
      }
    </Modal>
    
  )
  
}